import { h, Component } from 'preact';
import {JavaScriptIcon, ReactIcon, ReduxIcon, FirebaseIcon, NodeIcon, ExpressIcon, GithubIcon, HerokuIcon, CssIcon, HtmlIcon} from './../Icons'

export default class BestChat extends Component {
	state = {
		showFull: false
	}

  render() {
    return (
      <section class="Content border">
			<div class="Container small">
				<div class="Title center margin">
					<span class="text">Side Projects</span>
				</div>
			</div>

        <div class="Container">
          <div class="Product">
            <div class="info">
              <div class="Title">
                <span class="text">bestchat v0.5, 2017</span>
              </div>
              <p>
              	PWA Tech Demo: A feature-rich chat application for every browser. Built with minimal dependencies.
              </p>
							<span style={{ width:'100%' }}>
								<JavaScriptIcon />
								<ReactIcon />
								<ReduxIcon />
								<NodeIcon />
								<ExpressIcon />
								<FirebaseIcon />
								<HtmlIcon />
								<CssIcon />
							</span>
              <a href="https://chat.samcor.in" class="Button">View App</a>
              <a href="https://github.com/samcorin/bestChat" class="Button">Source Code</a>
            </div>
            <div class="Image shadow border">
              <img src="https://firebasestorage.googleapis.com/v0/b/homepage-b9f4a.appspot.com/o/bestchat.png?alt=media&token=69f23c09-516a-4761-ad10-08080c923d85" class="bestchat" style={{ border: 'none', boxShadow: 'none', height: '360px', width: 'auto' }} alt="bestChat" />
            </div>
          </div>
        </div>
      </section>
		);
	}
}



// WEBPACK FOOTER //
// ./components/bestchat/index.js